module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_6.a462d48a.png";